/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsUpDownToLines: {
  name: 'arrows-up-down-to-lines';
  data: string;
} = {
  name: 'arrows-up-down-to-lines',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm0 18a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm8.707-14.707a1 1 0 0 0-1.414 0l-3 3a1 1 0 0 0 1.414 1.414L11 9.414v5.172l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 14.586V9.414l1.293 1.293a1 1 0 0 0 1.414-1.414l-3-3Z" fill="currentColor"/></svg>`,
};
